import React, { useState } from 'react';
import { Button } from '@opendate-app/setlist';
import { toastSuccess, toastError } from '../../../shared/toastHelper';
import { ledgerLineItemExportsPath } from '../utils/ledgerLineItems';

const axios = require('axios').default;

function LedgerLineItemsExportButton({ team, csrfToken, params, label = 'Export Line Items' }) {
  const [submitting, setSubmitting] = useState(false);

  const handleClick = () => {
    setSubmitting(true);
    if (csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(ledgerLineItemExportsPath(team.id), params)
      .then(() => toastSuccess("Line item export started — you'll receive an email when it's ready to download"))
      .catch((err) => toastError(err.response?.data?.error || 'Could not start the line item export, something went wrong'))
      .finally(() => setSubmitting(false));
  };

  return (
    <Button size="sm" variant="secondary" disabled={submitting} onClick={handleClick}>
      {submitting ? 'Starting…' : label}
    </Button>
  );
}

export default LedgerLineItemsExportButton;
